export default {
  hotspots: {
    Office: {
      id: 'Office',
      envs: [
        {
          leftPct: '76.5',
          topPct: '26.5'
        }
      ]
    },
    PlantAnalytics: {
      id: 'PlantAnalytics',
      envs: [
        {
          leftPct: '30',
          topPct: '26.5'
        }
      ]
    },
    Mobile: {
      id: 'Mobile',
      envs: [
        {
          leftPct: '35.5',
          topPct: '57'
        }
      ]
    },
    InjectionMolder: {
      id: 'InjectionMolder',
      envs: [
        {
          leftPct: '39.5',
          topPct: '19'
        }
      ]
    },
    Heat: {
      id: 'Heat',
      envs: [
        {
          leftPct: '50',
          topPct: '43'
        }
      ]
    },
    Paint: {
      id: 'Paint',
      envs: [
        {
          leftPct: '59',
          topPct: '33'
        }
      ]
    },
    PackLabel: {
      id: 'PackLabel',
      envs: [
        {
          leftPct: '74.5',
          topPct: '57'
        }
      ]
    },
    Shipping: {
      id: 'Shipping',
      envs: [
        {
          leftPct: '54.5',
          topPct: '56.5'
        }
      ]
    }
  }
}
